import { render } from "./ResetComplete.vue?vue&type=template&id=fd0e12cc&scoped=true"
import script from "./ResetComplete.vue?vue&type=script&lang=js"
export * from "./ResetComplete.vue?vue&type=script&lang=js"

import "./ResetComplete.vue?vue&type=style&index=0&id=fd0e12cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0e12cc"]])

export default __exports__